import script from "./PUR03_035INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR03_035INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR03_035INS.vue?vue&type=style&index=0&id=8cb0179a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cb0179a"]])

export default __exports__